import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration, DeclarationCustomsType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  declaration: Partial<Declaration>;
  reason: string;
}

export const useInvalidateOneHv = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declaration, reason }: HookProps) => {
      if (declaration.customsState) {
        const sentTo = [DeclarationCustomsType.AES, DeclarationCustomsType.NL_AES, DeclarationCustomsType.IDMS, DeclarationCustomsType.DMS].includes(
          declaration.customsState?.sentTo,
        );
        await request({
          path: `${sentTo ? 'idms/invalidate' : 'declarations/invalidate-one-released-to-plda'}`,
          method: 'POST',
          authenticate: true,
          dataObject: { LRN: declaration.messageInfo.LRN, reason },
        });
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declaration._id] });
      toast.success('Invalidation request was sent!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the invalidation request!`);
    },
  });
};
